var JoyCommentType;
(function (JoyCommentType) {
    JoyCommentType["audio"] = "audio";
    JoyCommentType["text"] = "text";
})(JoyCommentType || (JoyCommentType = {}));
export default JoyCommentType;
//# sourceMappingURL=JoyCommentType.js.map